import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "changeordertype",
    standalone: true
})
export class ChangeOrderTypePipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 0:
                return "JIO";
            case 1:
                return "Plan";
            case 2:
                return "Elevation";
            case 3:
                return "Handing";
            case 4:
                return "ChoiceAttribute";
            case 5:
                return "HomesiteTransfer";
            case 6:
                return "NonStandardOption";
            case 7:
                return "Cancellation";
            case 8:
                return "SpecJIO";
            case 9:
                return "Buyer Change Order"
            case 10:
                return "Price Adjustment";
            case 11:
                return "SalesNotes";
            default:
                return "";
        }
    }
}
